import styled from "@emotion/styled";
import bgImage from "../assets/bgImage.png";

const ApplyLeaveStyle = styled.div({
  position: "relative",
  background: `url(${bgImage})`,
  objectFit: "cover",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundAttachment: "fixed",
  backgroundPosition: "center center",

  "& .ant-form-item-label>label.ant-form-item-required:not(.ant-form-item-required-mark-optional):before":
    {
      content: "none",
    },
  "& .TwoDates": {
    display: "flex",
    alignItems: "center",
  },
  "& .ant-typography": {
    color: "#244DA0",
  },
  "& .ant-form-item-label": {
    fontWeight: "600",
  },
  "& .ant-btn": {
    backgroundColor: "#244DA0",
    color: "white",
    fontWeight: "600",
    borderColor: "#244DA0",
  },
  "& .ant-btn-primary": {
    borderColor: "#244DA0",
    backgroundColor: "#244DA0",
    borderRadius: "2px",
    color: "white",
    fontWeight: "500",
    float: "right",
  },
});

export default ApplyLeaveStyle;
